<template>
  <component
    :aria-labelledby="'draggable-assistive-text' + draggableId"
    :class="cssClasses"
    :style="style"
    :is="tag"
    v-show="show"
    v-bind="attributeBindings"
    v-on="$listeners"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @focus="hover = true"
    @blur="hover = false"
  >
    <slot></slot>
    <span
      v-if="assistiveText"
      :id="'draggable-assistive-text' + draggableId"
      class="comet-screenreader-only"
      >{{ `Select Drag, ${assistiveText}` }}</span
    >
  </component>
</template>

<script>
import DraggableMixin from '../mixins/DraggableMixin';

export default {
  name: 'Draggable',
  mixins: [DraggableMixin],
};
</script>

<style lang="stylus" scoped>
.drag
  touch-action: none;
  position: relative
  box-sizing: border-box;
  cursor move /* fallback if grabbing cursor is unsupported */
  cursor grab
  cursor -moz-grab
  cursor -webkit-grab
  -webkit-touch-callout none
  -webkit-user-select none
  -khtml-user-select none
  -moz-user-select none
  -ms-user-select none
  user-select none

  &-out
    outline none
    user-select none
    cursor move /* fallback if grabbing cursor is unsupported */
    cursor grabbing
    cursor -moz-grabbing
    cursor -webkit-grabbing

  &-in
    transition transform 0.4s linear

  &-disable
    cursor: not-allowed
</style>
